<template>
  <v-app>
    <v-main>
      <table-page
        :headers="headers"
        :items="storageContainerShelfs"
        :rowCount="25"
      />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getStorageContainerShelfs"]),
  },
  created() {
    this.getStorageContainerShelfs();
  },
  computed: {
    ...mapGetters(["currentInstitution", "storageContainerShelfs"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Storage Container",
          value: "storageContainer.title",
        },
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Code", value: "code" },
        { text: "Rows", value: "rows" },
        { text: "Columns", value: "columns" },
        {
          text: "Position Labeling Option",
          value: "positionLabelingOption.title",
        },
        {
          text: "Row Labeling Schema",
          value: "rowLabelingSchema.title",
        },
        {
          text: "Column Labeling Schema",
          value: "columnLabelingSchema.title",
        },
      ],
      items: [],
    };
  },
};
</script>